(function () {
  if (!window.location.pathname.endsWith('/collections/scribing-tools')) {
    return;
  }

  const pagination = document.querySelector('.pagination-wrapper');
  const gridContainer = document.getElementById('ProductGridContainer');

  function getGridItems() {
    const grid = document.getElementById('product-grid');
    if (!grid) {
      return [];
    }

    return [...grid.querySelectorAll('.grid__item[data-ovs-scribing-filter]')];
  }

  function parseList(param) {
    const raw = new URLSearchParams(window.location.search).get(param);
    if (!raw) {
      return [];
    }

    return raw
      .split(',')
      .map((value) => value.trim())
      .filter((value) => value !== '');
  }

  function selectedTypes() {
    const types = new Set();

    document.querySelectorAll('.ovs-scribing-type-input:checked').forEach((input) => {
      const type = input.getAttribute('data-ovs-scribing-filter') || '';
      if (type !== '') {
        types.add(type);
      }
    });

    return [...types];
  }

  function syncCheckboxLabels() {
    document.querySelectorAll('.ovs-scribing-type-input').forEach((input) => {
      const label = input.closest('.ovs-scribing-type-option');
      if (label) {
        label.classList.toggle('active', input.checked);
      }
    });
  }

  function syncPanels(changedInput) {
    const type = changedInput.getAttribute('data-ovs-scribing-filter') || '';
    if (type === '') {
      return;
    }

    document
      .querySelectorAll(`.ovs-scribing-type-input[data-ovs-scribing-filter="${type}"]`)
      .forEach((input) => {
        input.checked = changedInput.checked;
      });
  }

  function syncCheckboxesFromUrl() {
    const types = parseList('ovs_scribing_type');

    document.querySelectorAll('.ovs-scribing-type-input').forEach((input) => {
      const type = input.getAttribute('data-ovs-scribing-filter') || '';
      input.checked = types.includes(type);
    });

    syncCheckboxLabels();
  }

  function buildUrl(types) {
    const url = new URL(window.location.href);
    url.searchParams.delete('ovs_scribing_type');
    url.searchParams.delete('page');

    if (types.length > 0) {
      url.searchParams.set('ovs_scribing_type', types.join(','));
    }

    return url;
  }

  function updateProductCount(visibleCount) {
    const countNodes = document.querySelectorAll(
      '#ProductCountDesktop, #ProductCountMobile, .product-count__text span',
    );
    countNodes.forEach((node) => {
      if (visibleCount === 1) {
        node.textContent = '1 product';
      } else {
        node.textContent = visibleCount + ' products';
      }
    });
  }

  function togglePagination(types) {
    if (!pagination) {
      return;
    }

    pagination.hidden = types.length > 0;
  }

  function setItemVisibility(item, show) {
    item.hidden = !show;
    item.classList.toggle('hidden', !show);
    item.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  function applyFilters(updateHistory) {
    const types = selectedTypes();
    let visibleCount = 0;

    getGridItems().forEach((item) => {
      const itemType = item.getAttribute('data-ovs-scribing-filter') || '';
      let show = true;

      if (types.length > 0) {
        show = itemType !== '' && types.includes(itemType);
      }

      setItemVisibility(item, show);
      if (show) {
        visibleCount += 1;
      }
    });

    syncCheckboxLabels();
    updateProductCount(visibleCount);
    togglePagination(types);

    if (updateHistory) {
      const url = buildUrl(types);
      window.history.pushState({ ovsScribingFilters: true }, '', url.pathname + url.search);
    }
  }

  function stopFacetFormPropagation(event) {
    event.stopPropagation();
  }

  document.querySelectorAll('.ovs-scribing-type-input').forEach((input) => {
    input.addEventListener('input', stopFacetFormPropagation);
    input.addEventListener('change', (event) => {
      stopFacetFormPropagation(event);
      syncPanels(input);
      applyFilters(true);
    });
  });

  window.addEventListener('popstate', () => {
    syncCheckboxesFromUrl();
    applyFilters(false);
  });

  if (gridContainer) {
    const observer = new MutationObserver(() => {
      if (selectedTypes().length > 0) {
        applyFilters(false);
      }
    });

    observer.observe(gridContainer, { childList: true, subtree: true });
  }

  syncCheckboxesFromUrl();
  applyFilters(false);
})();
